import React, { useState, useEffect } from 'react';

import './CookieAlert.css'; 
 
const CookieAlert = () => {
  const [mostrarCookieAlert, setmostrarCookieAlert] = useState(false);

  useEffect(() => {
    const cookieAceito = localStorage.getItem('cookiesAccepted');
    if (!cookieAceito) {
      setmostrarCookieAlert(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setmostrarCookieAlert(false);
  };

  return (
    <div>
     

      <div className="cookie-alert">
      {mostrarCookieAlert && (
        <div className="cookie-pop">
          <p>
            Ce site utilise des cookies nécessaires pour assurer son bon fonctionnement. 
             <br></br>
            Plus d'informations : <a href="/politique-de-confidentialite" className="privacy-link">Politique</a>
           
          </p>
            <button onClick={handleAcceptCookies} className="btn-accept">Ok</button>
        
          
        </div>
      )}
               
      </div>
    </div>
  );
};

export default CookieAlert;